/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AIModel,
    AIModelFromJSON,
    AIModelFromJSONTyped,
    AIModelToJSON,
} from './';

/**
 * 
 * @export
 * @interface ImportAIModelResponse
 */
export interface ImportAIModelResponse {
    /**
     * 
     * @type {Array<AIModel>}
     * @memberof ImportAIModelResponse
     */
    models: Array<AIModel>;
}

export function ImportAIModelResponseFromJSON(json: any): ImportAIModelResponse {
    return ImportAIModelResponseFromJSONTyped(json, false);
}

export function ImportAIModelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportAIModelResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'models': ((json['models'] as Array<any>).map(AIModelFromJSON)),
    };
}

export function ImportAIModelResponseToJSON(value?: ImportAIModelResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'models': ((value.models as Array<any>).map(AIModelToJSON)),
    };
}


